export const transmissionTaskState = {
  taskList: [],
  tasksExpanded: false,
  currentTask: {},
  taskSubmitting: false,
  taskFocused: false,
  isEditReportTask: false,
};
